// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as JsxRuntime from "react/jsx-runtime";
import InputWrapperModuleCss from "./InputWrapper.module.css";

let classes = InputWrapperModuleCss;

function InputWrapper$ErrorMessage(props) {
  return <p
    className={classes.errorMessage}
    id={props.id}
    role={"alert"}
  >
    {props.message}
  </p>;
}

let ErrorMessage = {
  make: InputWrapper$ErrorMessage
};

function InputWrapper(props) {
  let unitSlot = props.unitSlot;
  let inputName = props.inputName;
  let inputError = props.inputError;
  let unitId = unitSlot !== undefined ? inputName + `_unit` : "";
  let hasError = inputError !== undefined;
  let errorId = hasError ? inputName + `_error` : "";
  return <div
    className={`inputWrapper ` + Stdlib_Option.getOr(props.className, "")}
  >
    <label
      htmlFor={inputName}
    >
      {props.labelSlot}
    </label>
    <div>
      <div>
        {React.cloneElement(props.inputSlot, {
          "aria-describedby": errorId + ` ` + unitId,
          "aria-invalid": hasError ? "true" : "false",
          id: inputName,
          name: inputName
        })}
        {unitSlot !== undefined ? <p
            className={classes.description}
            id={unitId}
          >
            {unitSlot}
          </p> : null}
      </div>
      {inputError !== undefined ? <ErrorMessage.make
          id={errorId}
          message={inputError}
        /> : null}
    </div>
  </div>;
}

let make = InputWrapper;

export {
  classes,
  ErrorMessage,
  make,
}
/* classes Not a pure module */
